// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../orca-ui/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../orca-ui/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#orca-promo-button {
  padding: 0;
  border-color: white !important;
  background-color: transparent !important;
  transition: border-width 0.5s ease-in-out;
}

#orca-promo-button.live {
  border-color: red !important;
}

#orca-promo-button.livePreview {
  border-color: white !important;
  background-color: white !important;
}

#orca-promo-wrapper:hover #orca-promo-button,
#orca-promo-button.buffer {
  border-width: 1px !important;
}

#orca-promo-button svg {
  z-index: 1;
  color: black;
  transition: color 0.35s step-end;
}

#orca-promo-button.live svg {
  color: white;
}

#orca-promo-button.livePreview svg {
  color: #111 !important;
}

#orca-promo-wrapper:hover #orca-promo-button svg,
#orca-promo-button.buffer svg {
  color: white;
  transition: none;
}

.mini #orca-promo-button,
.small #orca-promo-button {
  min-width: 40px;
  min-height: 40px;
  border-width: 20px;
}

.mini #orca-promo-button svg,
.small #orca-promo-button svg {
  width: 16px;
  height: 16px;
  margin: -18px;
}

.medium #orca-promo-button {
  min-width: 56px;
  min-height: 56px;
  border-width: 28px;
}

.medium #orca-promo-button svg {
  width: 24px;
  height: 24px;
  margin: -12px;
}

.large #orca-promo-button {
  min-width: 64px;
  min-height: 64px;
  border-width: 32px;
}

.large #orca-promo-button svg {
  width: 28px;
  height: 28px;
  margin: -14px;
}

.mini #orca-promo-title,
.small #orca-promo-title {
  font-size: 14px;
}

.medium #orca-promo-title,
.large #orca-promo-title {
  font-size: 20px;
}

.mini #orca-promo-duration,
.small #orca-promo-duration {
  font-size: 12px;
}

.medium #orca-promo-duration,
.large #orca-promo-duration {
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./../components/src/video/orca/components/Promo/promo.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,8BAA8B;EAC9B,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB","sourcesContent":["#orca-promo-button {\n  padding: 0;\n  border-color: white !important;\n  background-color: transparent !important;\n  transition: border-width 0.5s ease-in-out;\n}\n\n#orca-promo-button.live {\n  border-color: red !important;\n}\n\n#orca-promo-button.livePreview {\n  border-color: white !important;\n  background-color: white !important;\n}\n\n#orca-promo-wrapper:hover #orca-promo-button,\n#orca-promo-button.buffer {\n  border-width: 1px !important;\n}\n\n#orca-promo-button svg {\n  z-index: 1;\n  color: black;\n  transition: color 0.35s step-end;\n}\n\n#orca-promo-button.live svg {\n  color: white;\n}\n\n#orca-promo-button.livePreview svg {\n  color: #111 !important;\n}\n\n#orca-promo-wrapper:hover #orca-promo-button svg,\n#orca-promo-button.buffer svg {\n  color: white;\n  transition: none;\n}\n\n.mini #orca-promo-button,\n.small #orca-promo-button {\n  min-width: 40px;\n  min-height: 40px;\n  border-width: 20px;\n}\n\n.mini #orca-promo-button svg,\n.small #orca-promo-button svg {\n  width: 16px;\n  height: 16px;\n  margin: -18px;\n}\n\n.medium #orca-promo-button {\n  min-width: 56px;\n  min-height: 56px;\n  border-width: 28px;\n}\n\n.medium #orca-promo-button svg {\n  width: 24px;\n  height: 24px;\n  margin: -12px;\n}\n\n.large #orca-promo-button {\n  min-width: 64px;\n  min-height: 64px;\n  border-width: 32px;\n}\n\n.large #orca-promo-button svg {\n  width: 28px;\n  height: 28px;\n  margin: -14px;\n}\n\n.mini #orca-promo-title,\n.small #orca-promo-title {\n  font-size: 14px;\n}\n\n.medium #orca-promo-title,\n.large #orca-promo-title {\n  font-size: 20px;\n}\n\n.mini #orca-promo-duration,\n.small #orca-promo-duration {\n  font-size: 12px;\n}\n\n.medium #orca-promo-duration,\n.large #orca-promo-duration {\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
